import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, message, Modal } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const CHistorial = () => {
    const [historial, setHistorial] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [articulosSeleccionados, setArticulosSeleccionados] = useState([]);
    const { user } = useContext(LoginContext);

    useEffect(() => {
        fetchHistorial();
    }, []);

    const fetchHistorial = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${user.token}`,
            };
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/historial/all`, { headers });

            const transformedData = response.data.map((item) => ({
                ...item,
                tipoMovimiento: item.numeroRecibo ? 'Entrada' : 'Salida',
            }));

            setHistorial(transformedData);
        } catch (error) {
            message.error('Error al obtener el historial de movimientos');
        }
    };

    const handleReimprimir = async (record) => {
        try {
            const headers = {
                Authorization: `Bearer ${user.token}`,
            };

            const endpoint = record.numeroRecibo
                ? `/historial/recibo/reimprimir/${record._id}`
                : `/historial/remito/reimprimir/${record._id}`;

            const res = await axios.get(`${process.env.REACT_APP_API_URL}${endpoint}`, { headers });

            const byteCharacters = atob(res.data.pdf);
            const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, '_blank');
        } catch (err) {
            message.error("Error al generar PDF");
        }
    };

    const handleEliminarHistorial = (record) => {
        confirm({
            title: '¿Estás seguro que querés eliminar este historial?',
            icon: <ExclamationCircleOutlined />,
            content: `Esto eliminará el ${record.numeroRecibo ? 'recibo' : 'remito'} permanentemente.`,
            okText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            onOk: async () => {
                try {
                    const headers = {
                        Authorization: `Bearer ${user.token}`,
                    };
                    const tipo = record.numeroRecibo ? 'recibo' : 'remito';

                    await axios.delete(`${process.env.REACT_APP_API_URL}/historial/${record._id}?tipo=${tipo}`, { headers });

                    message.success(`${tipo} eliminado correctamente`);
                    fetchHistorial(); // recargar
                } catch (err) {
                    message.error('Error al eliminar historial');
                }
            }
        });
    };

    const handleVerArticulos = (articulos) => {
        setArticulosSeleccionados(articulos);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
    };

    const columns = [
        {
            title: 'Cliente',
            dataIndex: 'idCliente',
            key: 'cliente',
            render: (cliente) => cliente.razonSocial,
        },
        {
            title: 'Tipo Movimiento',
            dataIndex: 'tipoMovimiento',
            key: 'tipoMovimiento',
        },
        {
            title: 'Número',
            dataIndex: 'numero',
            key: 'numero',
            render: (text, record) => record.numeroRemito || record.numeroRecibo,
        },
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (fecha) => new Date(fecha).toLocaleString(),
        },
        {
            title: 'Acciones',
            key: 'acciones',
            render: (text, record) => (
                <>
                    <Button
                        type="primary"
                        onClick={() => handleVerArticulos(record.articulos)}
                        style={{ marginRight: 8 }}
                    >
                        Detalle
                    </Button>
                    <Button
                        onClick={() => handleReimprimir(record)}
                        style={{ marginRight: 8 }}
                    >
                        Imprimir
                    </Button>
                    <Button danger onClick={() => handleEliminarHistorial(record)}>
                        Eliminar
                    </Button>
                </>
            ),
        },
    ];

    return (
        <div>
            <h2>Historial de Movimientos</h2>
            <Table
                columns={columns}
                dataSource={historial}
                rowKey="_id"
                pagination={{ pageSize: 10 }}
            />

            <Modal
                title="Detalles de los Artículos"
                visible={isModalVisible}
                onCancel={handleModalClose}
                footer={[
                    <Button key="close" onClick={handleModalClose}>
                        Cerrar
                    </Button>,
                ]}
                width={800}
            >
                <Table
                    dataSource={articulosSeleccionados}
                    rowKey="_id"
                    pagination={false}
                    columns={[
                        {
                            title: 'Nombre',
                            dataIndex: 'articulo',
                            key: 'nombre',
                            render: (art) => art.nombre,
                        },
                        {
                            title: 'Marca',
                            dataIndex: 'articulo',
                            key: 'marca',
                            render: (art) => art.idmarca.nombre,
                        },
                        {
                            title: 'Categoría',
                            dataIndex: 'articulo',
                            key: 'categoria',
                            render: (art) => art.idcategoria.nombre,
                        },
                        {
                            title: 'Cantidad',
                            dataIndex: 'cantidad',
                            key: 'cantidad',
                        },
                        {
                            title: 'Posición',
                            dataIndex: 'posicion',
                            key: 'posicion',
                        },
                    ]}
                />
            </Modal>
        </div>
    );
};

export default CHistorial;